import { TmcContextService } from './../../../../../common/tmc-context.service';
import { Component, Input, Output, EventEmitter, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';


@Component({
  selector: 'app-action-tablet-header-station-tab',
  templateUrl: './action-tablet-header-station-tab.component.html',
  styleUrls: ['./action-tablet-header-station-tab.component.scss']
})
export class ActionTabletHeaderStationTabComponent implements OnDestroy {

  tmcContextSubscription: Subscription;

  stationId: number;
  stationName: string;

  @Input("stationId") set setStationId(stationId: number) {
    this.stationId = stationId;
    this.updateStationName();
  }

  @Input() selected: boolean;

  @Output()
  close = new EventEmitter<any>();

  @Output()
  select = new EventEmitter<any>();

  constructor(
    private tmcContextService: TmcContextService
  ) {
    this.tmcContextSubscription = this.tmcContextService.updated.subscribe(() => this.updateStationName());
  }

  ngOnDestroy() {
    if (this.tmcContextSubscription != null) {
      this.tmcContextSubscription.unsubscribe();
    }
  }

  closeTab() {
    this.close.next(this.stationId);
  }

  selectTab() {
    this.select.next(this.stationId);
  }

  private updateStationName() {
    if (this.stationId) {
      this.stationName = this.tmcContextService.findStationById(this.stationId)?.name;
    } else {
      this.stationName = null;
    }
  }

}
